import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { ScenarioBatteryExt } from '@/classes/scenario/battery/ScenarioBatteryExt';
import { ScenarioExt } from '@/classes/scenario/ScenarioExt';
import { Preset } from '@/services/referencesService';

const getDefaultFields = () => new ScenarioBatteryExt();

interface References {
  getBatteryRef: () => Promise<Preset<Record<string, string | number>>>
}

interface Dependencies {
  references: References
}

export const buildBatteryModule = ({ references }: Dependencies) => {

  @Module({
    namespaced: true
  })
  class BatteryModule extends VuexModule {

    private presets: Record<string, string | number> | null = null;

    @Action
    public async loadPresets() {
      return references.getBatteryRef()
        .then(presets => {
          if (presets) {
            this.context.commit('setPresets', presets);
          }
        });
    }

    @Mutation
    private setPresets(payload: Record<string, string | number> | null) {
      this.presets = payload;
    }

    get getConfig(): ScenarioExt {
      return new ScenarioExt(this.context.rootGetters['scenario/getFields']);
    }

    get getFields(): ScenarioBatteryExt {
      return this.getConfig.battery ? new ScenarioBatteryExt(this.getConfig.battery) : getDefaultFields();
    }

    get getPresets(): Record<string, string | number> | null {
      return this.presets;
    }
  }

  return BatteryModule;
};
